<template>

  <div>
    <v-dialog v-model="isDisplayed"
              :persistent="true"
              max-width="700px">
      <v-card>
        <p class="dialog-title">{{ dialogTitle }}</p>
        <v-card-text>
          <v-container fluid="fluid" grid-list-xl="grid-list-xl">

            <!-- NAME -->
            <v-flex>
              <v-text-field v-model="editedTeam.name" label="Name" placeholder="Name"></v-text-field>
            </v-flex>

            <!-- CLUB -->
            <v-flex>
              <NEWClubSelector ref="clubSelector"
                               :currentClubID="editedTeam.clubID"
                               :sportID="editedTeam.sportID"
                               :disabledText="'Please select a sport first'"
                               :label="'Club'"
                               @clubSelected="clubSelected"/>
            </v-flex>

            <!-- AGE -->
            <v-flex>
              <CategoryAgeSelector :currentCategoryAge="editedTeam.categoryAge"
                                   :federationID="federationID"
                                   :disabledText="'Please select a club first'"
                                   @categoryAgeSelected="categoryAgeSelected"/>
            </v-flex>

            <!-- GENDER -->
            <v-flex>
              <CategoryGenderSelector ref="categoryGenderSelector"
                                      :currentCategoryGender="editedTeam.categoryGender"
                                      :federationID="federationID"
                                      :disabledText="'Please select a club first'"
                                      @categoryGenderSelected="categoryGenderSelected"/>
            </v-flex>

          </v-container>

          <!-- BUTTONS -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary"
                   flat="flat"
                   @click.native="close">Cancel</v-btn>
            <v-btn color="primary"
                   @click.native="save">{{ dialogButton }}</v-btn>
          </v-card-actions>

          <!-- ERROR -->
          <v-flex>
            <v-spacer></v-spacer>
            <div class="error-message">{{ errorMessage }}</div>
          </v-flex>

        </v-card-text>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>

import SportSelector from '../common/SportSelector'
import FederationSelector from '../common/FederationSelector'
import NEWClubSelector from '../common/NEWClubSelector'
import CategoryAgeSelector from '../common/CategoryAgeSelector'
import CategoryGenderSelector from '../common/CategoryGenderSelector'

export default {
  name: 'Dialog',
  components: {
    FederationSelector,
    SportSelector,
    NEWClubSelector,
    CategoryAgeSelector,
    CategoryGenderSelector
  },
  props: [
    'dialog',
    'dialogState',
    'currentEditedTeam',
    'errorMessage'
  ],
  data () {
    return {
      isDisplayed: false,

      editedTeam: {
        name: '',
        clubID: '',
        categoryAge: '',
        categoryGender: ''
      },

      federationID: '',

      pendingCategoryAge: '',
      pendingCategoryGender: ''
    }
  },
  mounted () {
    if (this.currentEditedTeam) {
      this.setCurrentEditedTeam()
    }
    if (this.dialog) {
      this.isDisplayed = true
    }
  },
  methods: {
    setCurrentEditedTeam () {
      this.editedTeam = {
        name: this.currentEditedTeam.name,
        clubID: this.currentEditedTeam.clubID,
        categoryAge: this.currentEditedTeam.categoryAge,
        categoryGender: this.currentEditedTeam.categoryGender
      }
    },
    save () {
      if (this.dialogState === 'create') {
        this.$emit('createTeam', this.editedTeam, this.federationID)
      } else {
        this.$emit('editTeam', this.editedTeam, this.federationID)
      }
    },

    clubSelected (clubid) {
      this.editedTeam.clubID = clubid
    },
    categoryAgeSelected (categoryage) {
      this.editedTeam.categoryAge = categoryage
    },
    categoryGenderSelected (categorygender) {
      this.editedTeam.categoryGender = categorygender
    },

    close () {
      this.clearData()
      this.isDisplayed = false
    },
    clearData () {
      this.editedTeam = {
        name: '',
        clubID: '',
        categoryAge: '',
        categoryGender: ''
      }
      this.$refs.clubSelector.clear()
    }
  },
  computed: {
    dialogTitle () {
      return this.dialogButton + ' team'
    },

    dialogButton () {
      return this.dialogState.charAt(0).toUpperCase() + this.dialogState.slice(1)
    }
  },
  watch: {
    'editedTeam.clubID' () {
      if (this.editedTeam.clubID) {
        if (this.editedTeam.categoryAge) {
          this.pendingCategoryAge = this.editedTeam.categoryAge
        }
        if (this.editedTeam.categoryGender) {
          this.pendingCategoryGender = this.editedTeam.categoryGender
        }

        this.$store.dispatch('getClub', this.editedTeam.clubID)
          .then(resp => {
            this.federationID = resp.federationID

            if (this.pendingCategoryAge || this.pendingCategoryGender) {
              this.editedTeam.categoryAge = this.pendingCategoryAge
              this.editedTeam.categoryGender = this.pendingCategoryGender
              this.pendingCategoryAge = ''
              this.pendingCategoryGender = ''
            }
          })
      } else {
        this.federationID = ''
      }
    },
    'dialog' () {
      if (this.isDisplayed !== this.dialog) {
        this.isDisplayed = this.dialog
      }
    },
    'isDisplayed' () {
      if (!this.isDisplayed) {
        this.clearData()
        this.$emit('dialogClosed')
      }
    },
    'currentEditedTeam' () {
      if (this.currentEditedTeam) {
        this.setCurrentEditedTeam()
      }
    }
  }
}

</script>

<style lang="scss" scoped>

.dialog-title {
  font-size: 16px;
  text-align: center;
  font-weight: 700;
  padding-top: 20px;
}

.input-label {
  font-size: 0.84rem;
  color: #757575;
}

.error-message {
  color: red;
  text-align: end;
  font-weight: 700;
}

</style>



// WEBPACK FOOTER //
// src/components/teams/Dialog.vue